/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Streaming settings for Drop create (excludes featuredStreams — managed via dedicated streaming endpoints)
 * @export
 * @interface CreateDropStreamingSettings
 */
export interface CreateDropStreamingSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CreateDropStreamingSettings
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDropStreamingSettings
     */
    allowParticipantStreams?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDropStreamingSettings
     */
    discoverableInLiveHub?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDropStreamingSettings
     */
    requireApproval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDropStreamingSettings
     */
    showViewerCounts?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateDropStreamingSettings
     */
    maxFeaturedStreams?: number;
}

/**
 * Check if a given object implements the CreateDropStreamingSettings interface.
 */
export function instanceOfCreateDropStreamingSettings(value: object): value is CreateDropStreamingSettings {
    return true;
}

export function CreateDropStreamingSettingsFromJSON(json: any): CreateDropStreamingSettings {
    return CreateDropStreamingSettingsFromJSONTyped(json, false);
}

export function CreateDropStreamingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDropStreamingSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'allowParticipantStreams': json['allowParticipantStreams'] == null ? undefined : json['allowParticipantStreams'],
        'discoverableInLiveHub': json['discoverableInLiveHub'] == null ? undefined : json['discoverableInLiveHub'],
        'requireApproval': json['requireApproval'] == null ? undefined : json['requireApproval'],
        'showViewerCounts': json['showViewerCounts'] == null ? undefined : json['showViewerCounts'],
        'maxFeaturedStreams': json['maxFeaturedStreams'] == null ? undefined : json['maxFeaturedStreams'],
    };
}

export function CreateDropStreamingSettingsToJSON(json: any): CreateDropStreamingSettings {
    return CreateDropStreamingSettingsToJSONTyped(json, false);
}

export function CreateDropStreamingSettingsToJSONTyped(value?: CreateDropStreamingSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'allowParticipantStreams': value['allowParticipantStreams'],
        'discoverableInLiveHub': value['discoverableInLiveHub'],
        'requireApproval': value['requireApproval'],
        'showViewerCounts': value['showViewerCounts'],
        'maxFeaturedStreams': value['maxFeaturedStreams'],
    };
}

